import { ITemplate, ITemplateBuffer } from ".";

export class FileEditorController {
  protected template?: ITemplateBuffer;
  protected listeners: Array<(editor: FileEditorController) => void> = [];
  public onChange(listener: (editor: FileEditorController) => void) {
    this.listeners.push(listener);
  }
  public startEditing(temp: ITemplate) {
    console.log(`Start Editing`);
    if ('buffer' in temp) {
      this.template = temp;
      this.listeners.forEach(l => l(this));
    } else {
      console.error('No idea how to edit this template:', temp);
    }
  }
  public stopEditing() {
    this.template = undefined;
    this.listeners.forEach(l => l(this));
    console.log(`Stop Editing`);
  }
  public getTemplate() {
    return this.template;
  }
  public getBuffer() {
    return this.template ? this.template.buffer : null;
  }
  public setBuffer(buffer: ArrayBuffer): any {
    if (!this.template) return;
    this.template.buffer = buffer;
    this.listeners.forEach(l => l(this));
  }
}

export const MainFileEditorController = new FileEditorController();
export default MainFileEditorController;



// WEBPACK FOOTER //
// ./src/logic/fileeditor.ts